module.exports = __webpack_public_path__ + "img/20210118_161941.f808756d.jpg";